// extracted by mini-css-extract-plugin
export default {"regionList":"_9gbs0MkGTln1VBaJcYWG_N56uDaASvnHAnwxXcUECrg"};